import { type ReactNode, useEffect } from 'react';
import { ConfigProvider, App } from 'antd';
import { QueryClientProvider } from '@tanstack/react-query';
import { lightThemeConfig } from '@/shared/config';
import { type LanguageCode } from '@/shared/config/languages';
import { queryClient } from '@/shared/api';
import { applyLightTheme, useAppStore } from '@/shared/lib';
import { PermissionProvider } from './PermissionProvider';
import type { Locale } from 'antd/es/locale';
import uzUZ from 'antd/locale/uz_UZ';
import ruRU from 'antd/locale/ru_RU';
import enUS from 'antd/locale/en_US';

const antdLocaleMap: Record<LanguageCode, Locale> = {
  uz: uzUZ,
  ru: ruRU,
  en: enUS,
};

interface AppProvidersProps {
  children: ReactNode;
}

const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const language = useAppStore((state) => state.language);

  useEffect(() => {
    applyLightTheme();
  }, []);

  return (
    <ConfigProvider theme={lightThemeConfig} locale={antdLocaleMap[language]}>
      <App>{children}</App>
    </ConfigProvider>
  );
};

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <PermissionProvider>{children}</PermissionProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
